import React, { useEffect } from 'react';
import { ErrorMessage, useFormikContext } from 'formik';
import { MatchMakerAnswers } from '../../../../shared/types';
import { useTranslation } from 'react-i18next';
import { FieldError, NumericInput, TrackableComponent } from '../../../components';
import { Checkbox } from '@vwfs-bronson/bronson-react';

export function AdditionalDepositInput(): JSX.Element {
  const { t } = useTranslation('match-maker');
  const { setFieldValue, values } = useFormikContext<MatchMakerAnswers>();

  useEffect(() => {
    if (values.additionalDeposit === 0) {
      setFieldValue('noAdditionalDepositCheckbox', true);
    }
    if ((values.additionalDeposit as number) > 0) {
      setFieldValue('noAdditionalDepositCheckbox', false);
    }
  }, [values.additionalDeposit]);

  return (
    <div className="u-mt-large">
      <TrackableComponent trackingFunction="inputboxAdditionalDeposit" trackingComponent="inputbox">
        <NumericInput
          fieldName="additionalDeposit"
          placeholder={t('question-pages.items.additional-deposit.input-field.placeholder')}
          addonText={t('question-pages.items.additional-deposit.input-field.addon')}
        />
      </TrackableComponent>
      <ErrorMessage name="additionalDeposit">
        {(msg) => <FieldError id="additionalDeposit" errorMessage={msg} />}
      </ErrorMessage>
      <div className="u-mt-small">
        <Checkbox
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            setFieldValue('noAdditionalDepositCheckbox', e.target.checked);
            if (e.target.checked) {
              setFieldValue('additionalDeposit', 0);
            }
          }}
          checked={Boolean(values.noAdditionalDepositCheckbox)}
        >
          {t('question-pages.items.additional-deposit.checkboxText')}
        </Checkbox>
      </div>
    </div>
  );
}
